import { render, staticRenderFns } from "./ib-tab.vue?vue&type=template&id=4bfe9086&lang=pug&"
import script from "./ib-tab.vue?vue&type=script&lang=js&"
export * from "./ib-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bfe9086')) {
      api.createRecord('4bfe9086', component.options)
    } else {
      api.reload('4bfe9086', component.options)
    }
    module.hot.accept("./ib-tab.vue?vue&type=template&id=4bfe9086&lang=pug&", function () {
      api.rerender('4bfe9086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/ib-tab.vue"
export default component.exports